import React from 'react'
import RemoveIcon from './icons/remove'
import TimePickerV2 from '../../../../../../../Components/_newComponents/TimePickerV2'

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  innerContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '14px',
    width: '80%',
  },
  timePickerContainer: {
    width: '48%',
    gap: '10px',
    display: 'flex',
    flexDirection: 'column',
  },
  openingTimeContainer: {
    width: '48%',
    gap: '10px',
    display: 'flex',
    flexDirection: 'column',
    borderRight: '1px solid #E2E2FC',
  },
  timeLabel: {
    color: '#707087',
    fontFamily: 'Proxima Nova',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '18px',
  },
  tooltipContainer: {
    alignSelf: 'flex-end',
    marginBottom: 6,
  },
  removeButton: {
    width: 'fit-content',
    background: 'transparent',
    border: 'none',
    padding: 0,
    alignSelf: 'flex-end',
  },
  errorMessage: {
    color: 'red',
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '18px',
  },
}

const TimeRangeRow = ({
  timeRange,
  onStartChange,
  onEndChange,
  onRemove,
  isLast,
  validationErrors,
  isRemoveButtonVisible,
  errorKey = 'breakTimes',
}) => {
  return (
    <div style={styles.container}>
      <div style={styles.contentContainer}>
        <div
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
          }}
        >
          <div style={styles.innerContainer}>
            <div style={styles.openingTimeContainer}>
              <div style={styles.timeLabel}>Opening Time</div>
              <TimePickerV2
                value={timeRange.start}
                onChange={time => onStartChange(timeRange.id, time)}
                placeholders={{
                  hours: '09',
                  minutes: '00',
                  period: 'AM',
                }}
                error={
                  validationErrors[
                    `${errorKey}-${timeRange.id}-start-overlap`
                  ] || validationErrors[`${errorKey}-${timeRange.id}-start`]
                }
              />
            </div>
            <div style={styles.timePickerContainer}>
              <div style={styles.timeLabel}>Closing Time</div>
              <TimePickerV2
                value={timeRange.end}
                onChange={time => onEndChange(timeRange.id, time)}
                placeholders={{
                  hours: '06',
                  minutes: '00',
                  period: 'PM',
                }}
                error={
                  validationErrors[`${errorKey}-${timeRange.id}-end-overlap`] ||
                  validationErrors[`${errorKey}-${timeRange.id}-end`]
                }
              />
            </div>
          </div>
          {isRemoveButtonVisible && (
            <button
              style={styles.removeButton}
              onClick={() => onRemove(timeRange.id)}
            >
              <RemoveIcon />
            </button>
          )}
        </div>
      </div>
      {!isLast && (
        <div
          style={{
            borderBottom: '1px solid #E2E2FC',
            width: '100%',
            marginTop: 8,
          }}
        />
      )}
    </div>
  )
}

export default TimeRangeRow
